var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAudioMuted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1478 1.32987C15.1478 0.599533 14.612 0 13.862 0C13.337 0 12.9834 0.228913 12.4156 0.773942L8.0119 5.00337C7.94761 5.06878 7.88333 5.11238 7.80833 5.13418L7.36903 5.15598L15.1478 13.0698V1.32987ZM18.5871 20.7547C18.9193 21.0818 19.4443 21.0818 19.755 20.7547C20.0764 20.4168 20.0872 19.8936 19.755 19.5666L1.41176 0.90475C1.09032 0.577732 0.554598 0.577732 0.233163 0.90475C-0.0775582 1.22087 -0.0775582 1.7768 0.233163 2.09291L18.5871 20.7547ZM4.20825 14.5959H7.40117C7.50832 14.5959 7.60475 14.6286 7.66904 14.694L12.4156 19.2832C12.9299 19.7737 13.3584 19.9917 13.8835 19.9917C14.3763 19.9917 14.7728 19.7301 14.9656 19.3486C15.0085 19.2505 15.0513 19.1414 15.0835 19.0215L2.41892 6.13704C2.06535 6.52946 1.8832 7.12899 1.8832 7.90293V12.1215C1.8832 13.7566 2.6975 14.5959 4.20825 14.5959Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAudioMuted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-audio-muted.6c88c23f9f9e3edf5f3cf33ac85873bf.svg";